/**
 * R2IT Golf Scoring API
 * This swagger document describes the available API endpoints.
 *
 * OpenAPI spec version: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { MicrosoftAspNetCoreMvcProblemDetails } from '../model/microsoftAspNetCoreMvcProblemDetails';
import { ModulesReportsApplicationReportCategoriesReportCategoryResponse } from '../model/modulesReportsApplicationReportCategoriesReportCategoryResponse';
import { ModulesReportsApplicationReportParameterDependenciesReportParameterDependencyResponse } from '../model/modulesReportsApplicationReportParameterDependenciesReportParameterDependencyResponse';
import { ModulesReportsApplicationReportParameterLinksReportParameterLinkResponse } from '../model/modulesReportsApplicationReportParameterLinksReportParameterLinkResponse';
import { ModulesReportsApplicationReportParametersReportParameterResponse } from '../model/modulesReportsApplicationReportParametersReportParameterResponse';
import { ModulesReportsApplicationReportsExecuteReportReportExecutionResponse } from '../model/modulesReportsApplicationReportsExecuteReportReportExecutionResponse';
import { ModulesReportsApplicationReportsReportResponse } from '../model/modulesReportsApplicationReportsReportResponse';
import { ModulesReportsEndpointsContractsReportsExecuteReportRequest } from '../model/modulesReportsEndpointsContractsReportsExecuteReportRequest';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { ReportsServiceInterface }                            from './reports.serviceInterface';


@Injectable()
export class ReportsService implements ReportsServiceInterface {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Executes a report and returns the rendered artifact.
     * Executes the specified report using the supplied context and returns the rendered artifact in base64 format.
     * @param reportId 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public executeReportEndpoint(reportId: string, body?: ModulesReportsEndpointsContractsReportsExecuteReportRequest, observe?: 'body', reportProgress?: boolean): Observable<ModulesReportsApplicationReportsExecuteReportReportExecutionResponse>;
    public executeReportEndpoint(reportId: string, body?: ModulesReportsEndpointsContractsReportsExecuteReportRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ModulesReportsApplicationReportsExecuteReportReportExecutionResponse>>;
    public executeReportEndpoint(reportId: string, body?: ModulesReportsEndpointsContractsReportsExecuteReportRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ModulesReportsApplicationReportsExecuteReportReportExecutionResponse>>;
    public executeReportEndpoint(reportId: string, body?: ModulesReportsEndpointsContractsReportsExecuteReportRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (reportId === null || reportId === undefined) {
            throw new Error('Required parameter reportId was null or undefined when calling executeReportEndpoint.');
        }


        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ModulesReportsApplicationReportsExecuteReportReportExecutionResponse>('post',`${this.basePath}/reports/${encodeURIComponent(String(reportId))}/execute`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets all Report Categories.
     * Gets all Report Categories.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getReportCategoriesEndpoint(observe?: 'body', reportProgress?: boolean): Observable<Array<ModulesReportsApplicationReportCategoriesReportCategoryResponse>>;
    public getReportCategoriesEndpoint(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ModulesReportsApplicationReportCategoriesReportCategoryResponse>>>;
    public getReportCategoriesEndpoint(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ModulesReportsApplicationReportCategoriesReportCategoryResponse>>>;
    public getReportCategoriesEndpoint(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ModulesReportsApplicationReportCategoriesReportCategoryResponse>>('get',`${this.basePath}/reports/categories`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets all Report Parameter Dependencies.
     * Gets all Report Parameter Dependencies.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getReportParameterDependenciesEndpoint(observe?: 'body', reportProgress?: boolean): Observable<Array<ModulesReportsApplicationReportParameterDependenciesReportParameterDependencyResponse>>;
    public getReportParameterDependenciesEndpoint(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ModulesReportsApplicationReportParameterDependenciesReportParameterDependencyResponse>>>;
    public getReportParameterDependenciesEndpoint(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ModulesReportsApplicationReportParameterDependenciesReportParameterDependencyResponse>>>;
    public getReportParameterDependenciesEndpoint(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ModulesReportsApplicationReportParameterDependenciesReportParameterDependencyResponse>>('get',`${this.basePath}/reports/parameter-dependencies`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets all Report Parameter Links.
     * Gets all Report Parameter Links.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getReportParameterLinksEndpoint(observe?: 'body', reportProgress?: boolean): Observable<Array<ModulesReportsApplicationReportParameterLinksReportParameterLinkResponse>>;
    public getReportParameterLinksEndpoint(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ModulesReportsApplicationReportParameterLinksReportParameterLinkResponse>>>;
    public getReportParameterLinksEndpoint(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ModulesReportsApplicationReportParameterLinksReportParameterLinkResponse>>>;
    public getReportParameterLinksEndpoint(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ModulesReportsApplicationReportParameterLinksReportParameterLinkResponse>>('get',`${this.basePath}/reports/parameter-links`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets all Report Parameters.
     * Gets all Report Parameters.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getReportParametersEndpoint(observe?: 'body', reportProgress?: boolean): Observable<Array<ModulesReportsApplicationReportParametersReportParameterResponse>>;
    public getReportParametersEndpoint(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ModulesReportsApplicationReportParametersReportParameterResponse>>>;
    public getReportParametersEndpoint(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ModulesReportsApplicationReportParametersReportParameterResponse>>>;
    public getReportParametersEndpoint(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ModulesReportsApplicationReportParametersReportParameterResponse>>('get',`${this.basePath}/reports/parameters`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets all Reports.
     * Gets all Reports.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getReportsEndpoint(observe?: 'body', reportProgress?: boolean): Observable<Array<ModulesReportsApplicationReportsReportResponse>>;
    public getReportsEndpoint(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ModulesReportsApplicationReportsReportResponse>>>;
    public getReportsEndpoint(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ModulesReportsApplicationReportsReportResponse>>>;
    public getReportsEndpoint(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ModulesReportsApplicationReportsReportResponse>>('get',`${this.basePath}/reports`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
